export const getEducationLevels = (): string[] => ([
    'primary',
    'vocational',
    'high school',
    'bachelors degree',
    'masters degree',
    'other'
]);
